<template>
  <div class="main-container">
    <!-- 添加编辑 -->
    <el-dialog
      :title="editType==1?'添加':'编辑'"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        ref="editForm"
        :rules="editRules"
      >

        <el-row>
          <el-form-item
            label="应用类别"
            prop="AppType"
          >
            <el-select
              v-model="editForm.AppType"
              placeholder="请选择应用类别"
              style="width:100%"
              clearable
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="版本号"
            prop="Verion"
          >
            <el-input
              v-model="editForm.Verion"
              autocomplete="off"
              placeholder="请输入版本号"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="文件地址"
            prop="Url"
          >
            <el-input
              v-model="editForm.Url"
              autocomplete="off"
              placeholder="请输入文件地址"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注"
              v-model="editForm.Remark"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>

      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('editForm')"
          :loading="sumbitLoading"
        >确 定</el-button>
      </div>
    </el-dialog>
    <div class="toolBox">
      <div class="leftBox">
        <el-form
          :inline="true"
          :model="searchForm"
          class="searchForm"
          size="mini"
        >
          <el-form-item
            label="版本号"
            style="margin-bottom:0"
          >
            <el-input
              v-model="searchForm.Verion"
              placeholder="请输入版本号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:0">
            <el-button
              type="primary"
              @click="search"
            >查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="rightBox">
        <el-button
          icon="el-icon-plus"
          @click="add"
          size="mini"
        >添加</el-button>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="table.data"
        border
        height="100%"
        stripe
        size="mini"
        style="width: 100%"
        :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
        :cell-style="{textAlign:'center'}"
        v-loading="table.loading"
      >
        <el-table-column
          prop="AppType"
          label="应用类别"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="Verion"
          label="版本号"
           minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="Url"
          label="文件地址"
           minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="Remark"
          label="备注说明"
           minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="更新时间"
           minwidth="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="UserName"
          label="创建人"
          width="120"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="edit(scope.row)"
            >编辑</el-button>
            <el-popconfirm
              :title="`确认删除版本「${scope.row.Verion}」吗`"
              style="margin:0 10px"
              @confirm="del(scope.row.AppID)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
              >删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="listPage admin_page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="table.pageNum"
        :page-sizes="[15,30,45]"
        :page-size="table.pageSize"
        layout="total,prev, pager, next, sizes, jumper"
        :total="table.total"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      sumbitLoading: false,
      table: {
        data: [],
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      typeOptions: [
        {
          value: "gatewaydown",
          label: "gatewaydown",
        },
        {
          value: "gatewayup",
          label: "gatewayup",
        },
      ],
      searchForm: {
        Verion: null,
      },
      statusOptions: [
        {
          value: 1,
          label: "正常",
        },
        {
          value: 3,
          label: "禁用",
        },
      ],
      editType: 1, //1添加2编辑
      editFormVisible: false,
      editForm: {},
      editRules: {
        AppType: [
          {
            required: true,
            message: "请选择应用类别",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    ...mapGetters(["SessionId", "UserId"]),
  },
  mounted() {
    this.getList();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "editForm") {
            this.sumbit();
          }
        } else {
          return false;
        }
      });
    },
    //翻页事件
    handleSizeChange(val) {
      this.table.pageSize = val;
      this.getList(this.searchForm);
    },
    //翻页事件
    handleCurrentChange(val) {
      this.table.pageNum = val;
      this.getList(this.searchForm);
    },
    add() {
      this.reset();
      this.editType = 1;
      this.editFormVisible = true;
    },
    edit(data) {
      this.reset();
      this.editForm = JSON.parse(JSON.stringify(data));
      this.editType = 2;
      this.editFormVisible = true;
    },
    // 表单重置
    reset() {
      this.editForm = {
        AppType: null,
        Verion: null,
        Url: null,
        Remark: null,
      };
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },
    search() {
      this.table.pageNum = 1;
      this.table.pageSize = 15;
      this.getList(this.searchForm);
    },
    async getList(searchForm) {
      this.table.loading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.table.pageNum,
          PageSize: this.table.pageSize,
          SearchList: [],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "CreateTime",
            },
          ],
        },
      };
      if (searchForm) {
        Object.keys(searchForm).forEach(function (key) {
          if (searchForm[key]) {
            obj.Params.SearchList.push({
              CompareType: "Contains",
              PropertyName: key,
              PropertyValue: searchForm[key],
            });
          }
        });
      }
      const res = await this.$api.axios_http(
        this.$gd.admin.verion.getList,
        obj,
        "POST"
      );
      this.table.loading = false;
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.CreateTime) {
              item.CreateTime = this.$moment(item.CreateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.table.total = res.RecordCount;
        this.table.data = res.ReturnList;
      } else {
        this.$message.error(res.Error);
      }
    },
    async del(AppID) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          AppID,
        },
      };
      //添加

      const res = await this.$api.axios_http(
        this.$gd.admin.verion.delete,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    async sumbit() {
      this.sumbitLoading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: { ...this.editForm },
      };
      //添加
      let res;
      if (this.editType === 1) {
        res = await this.$api.axios_http(
          this.$gd.admin.verion.add,
          obj,
          "POST"
        );
      } else {
        res = await this.$api.axios_http(
          this.$gd.admin.verion.edit,
          obj,
          "POST"
        );
      }
      this.sumbitLoading = false;
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.editFormVisible = false;
        if (this.editType === 1) {
          this.table.pageNum = 1;
          this.table.pageSize = 15;
        }
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .toolBox {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    box-sizing: border-box;
  }
  .content {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding-top: 0;
  }
}
</style>
